import {
  DEFAULT_ICON_COLOR,
  DEFAULT_ICON_OPACITY,
  DEFAULT_ICON_SIZE,
} from 'app-constants';
import { memo } from 'react';

import type { AppIconProps } from '../app-icon.types';

export const CloseIcon = memo(
  ({
    size = DEFAULT_ICON_SIZE,
    color = DEFAULT_ICON_COLOR,
    opacity = DEFAULT_ICON_OPACITY,
  }: AppIconProps) => {
    const { width, height } = size;

    return (
      <svg
        fill="none"
        height={height}
        viewBox="0 0 20 20"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity={opacity}>
          <rect
            height={height}
            style={{ mixBlendMode: 'multiply' }}
            width={width}
          />
          <path
            d="M15 5.875L14.125 5L10 9.125L5.875 5L5 5.875L9.125 10L5 14.125L5.875 15L10 10.875L14.125 15L15 14.125L10.875 10L15 5.875Z"
            fill={color}
          />
        </g>
      </svg>
    );
  },
);
